import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import { useRole } from "../../RoleProvider/RoleProvider";
import RefreshLoader from "../Loading";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { loading: authLoading } = useAuth();
  const { role, isLoading: roleLoading } = useRole();
  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    let timer;
    if (roleLoading || role === null) {
      // Start 5s countdown
      timer = setTimeout(() => {
        setTimeoutReached(true);
      }, 10000);
    }
    return () => clearTimeout(timer); // cleanup
  }, [roleLoading, role]);
  if (authLoading) {
    // Wait for auth to load
    return <RefreshLoader />;
  }

  // if (!user || !user?.token) {
  //   // Only redirect once auth is done
  //   return <Navigate to="/login" />;
  // }
  // console.log("Role is " + role);
  // console.log("ROle loading is " + roleLoading);
  // console.log("Timeout reached is " + timeoutReached)
  // console.log("user is " + user)
  if ((roleLoading || role === null) && !timeoutReached) {
    return <RefreshLoader />;
  }

  // After 5s, if still no role → go to login
  if ((roleLoading || role === null) && timeoutReached) {
    return <Navigate to="/student/start-your-quest" replace />;
  }

  if (Array.isArray(requiredRole)) {
    if (!requiredRole.includes(Number(role))) {
      return <Navigate to="/not-authorized" />;
    }
  } else {
    if (Number(role) !== Number(requiredRole)) {
      return <Navigate to="/not-authorized" />;
    }
  }

  return children;
};

export default ProtectedRoute;
